// extracted by mini-css-extract-plugin
module.exports = {"shadow":"WrapperStyles_shadow__54ZEt","wrapper":"WrapperStyles_wrapper__2qR1D"};